import { EARTH_RADIUS } from "../../../constants/geodesyConstants";

/** 緯度経度差をローカル平面(メートル)へ。基準は center(lat0,lng0) */
export function llToLocalXY(lat, lng, { lat0, lng0 }) {
  const R = EARTH_RADIUS;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(lat - lat0);
  const dLng = toRad(lng - lng0);
  const X = R * Math.cos(toRad(lat0)) * dLng;
  const Y = R * dLat;
  return { X, Y };
}

/** アフィン係数を適用して SVG 座標 (x,y) を返す */
function applyAffine(P, aff) {
  return {
    x: aff.a * P.X + aff.b * P.Y + aff.tx,
    y: aff.c * P.X + aff.d * P.Y + aff.ty,
  };
}

/** バリセントリック内点判定（前計算済み係数を利用） */
function isInsideTriangle(P, tri, eps = -1e-9) {
  const { A, v0x, v0y, v1x, v1y, d00, d01, d11, invDen } = tri;
  const v2x = P.X - A.X,
    v2y = P.Y - A.Y;
  const d20 = v2x * v0x + v2y * v0y;
  const d21 = v2x * v1x + v2y * v1y;
  const v = (d11 * d20 - d01 * d21) * invDen;
  const w = (d00 * d21 - d01 * d20) * invDen;
  const u = 1 - v - w;
  return u >= eps && v >= eps && w >= eps;
}

export function latLngToSvgPiecewise(lat, lng, model) {
  if (!model || !model.center) return null;
  // pre(JSON)でも復元モデルでも動くように配列を吸収
  const triangles = model.preparedTriangles ?? model.tris ?? [];
  if (!triangles.length) return null;

  const P = llToLocalXY(lat, lng, model.center);

  // 直前ヒット三角（schemaに依存しないprivateプロパティ）
  const lastIdxKey = "_lastIdx";
  if (Number.isInteger(model[lastIdxKey])) {
    const tri = triangles[model[lastIdxKey]];
    if (tri) {
      const b = tri.bbox;
      if (P.X >= b.minX && P.X <= b.maxX && P.Y >= b.minY && P.Y <= b.maxY) {
        if (isInsideTriangle(P, tri)) {
          model[lastIdxKey] = tri.idx ?? model[lastIdxKey];
          return applyAffine(P, tri.aff);
        }
      }
    }
  }
  // 総当たり（AABB→内点判定）
  for (let i = 0; i < triangles.length; i++) {
    const tri = triangles[i];
    const b = tri.bbox;
    if (P.X < b.minX || P.X > b.maxX || P.Y < b.minY || P.Y > b.maxY) continue;
    if (isInsideTriangle(P, tri)) {
      // 以後の高速化用に覚えておく
      model[lastIdxKey] = tri.idx ?? i;
      return applyAffine(P, tri.aff);
    }
  }
  // 凸包外
  return null;
}
